import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : null,
    "data": {}
}
const UpdateMediaUploadStateData = createSlice({
    name:'updateMediaUploadStateData',
    initialState,
    reducers:{
        updateMediaUploadStateData: (_state,payload)=>{
            return {
                ..._state,
                ...{
                "id" : uuidv4(),
                "data": {
                    ..._state.data,
                    [payload.payload.msgId]: payload.payload
                }
            }}}
    }
});

export default UpdateMediaUploadStateData.reducer
export const updateMediaUploadStateData = UpdateMediaUploadStateData.actions.updateMediaUploadStateData